"use client";

import { useEffect, useState } from "react";
import InstallButton from "@/components/InstallButton";
import { getProductById, type ProductId } from "@/lib/products";

interface StickyMobileInstallBarProps {
  product: ProductId;
  source: string;
  source_id?: string;
}

const SHOW_AFTER_PX = 600;
const HIDE_NEAR_BOTTOM_PX = 600;

export default function StickyMobileInstallBar({
  product,
  source,
  source_id,
}: StickyMobileInstallBarProps) {
  const [visible, setVisible] = useState(false);
  const productData = getProductById(product);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setVisible(y > SHOW_AFTER_PX && y < docHeight - HIDE_NEAR_BOTTOM_PX);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  if (!productData) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 md:hidden bg-background/95 backdrop-blur-md border-t border-border shadow-2xl transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      aria-hidden={!visible}
    >
      <div className="flex items-center gap-3 px-4 py-3 max-w-md mx-auto">
        <div className="flex-1 min-w-0">
          <p className="text-xs text-muted-foreground truncate font-mono">Free Chrome Extension</p>
          <p className="text-sm font-bold text-foreground truncate">{productData.alternateName}</p>
        </div>
        <InstallButton
          product={product}
          source={source}
          source_id={source_id}
          target="_blank"
          className="inline-flex h-11 items-center justify-center rounded-full bg-primary text-primary-foreground px-5 text-sm font-bold shadow-lg hover:bg-primary/90 transition-all flex-shrink-0 whitespace-nowrap"
        >
          Install Free
        </InstallButton>
      </div>
    </div>
  );
}
